import { useEffect } from 'react';
import { AiTeamRosterView, aiTeamRoster, setPlanFromUrl } from '@elva/ui';
import { useNavigate, useSearchParams } from 'react-router-dom';

export function AiTeamPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  // ?plan=core|full applies app-wide for the session (spec 37 §4).
  const planParam = params.get('plan');
  useEffect(() => {
    if (planParam === 'core' || planParam === 'full') setPlanFromUrl(planParam);
  }, [planParam]);

  return (
    <AiTeamRosterView
      data={aiTeamRoster()}
      fallback={params.get('fallback') === '1'}
      onOpen={(to) => { void navigate(to); }}
      onSeeSent={(logKey) => { void navigate(`/communications?agent=${logKey}&range=30d`); }}
      onOpenBrain={() => { void navigate('/settings/ai/general'); }}
      onOpenBrainChip={(to) => { void navigate(to); }}
      onOpenDashboard={() => { void navigate('/dashboard?period=30d'); }}
      onOpenTriage={() => { void navigate('/triage'); }}
      onOpenCalls={() => { void navigate('/calls'); }}
    />
  );
}
